var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"height":"24","width":"24","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M4 5a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h9a3 3 0 0 0 3-3v-2.057l3.837 2.741c1.324.946 3.163 0 3.163-1.627V8.943c0-1.627-1.839-2.573-3.163-1.627L16 10.056V8a3 3 0 0 0-3-3z","fill-rule":"evenodd"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }